import { useEffect, useState } from "react";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { Button } from "@/components/ui/button";
import { CheckCircle, Loader2 } from "lucide-react";
import { useTranslation } from "react-i18next";

export const Route = createFileRoute(
  "/workspace/$workspaceSlug/settings/workspace/billing/success",
)({
  component: PaymentSuccessPage,
});

function PaymentSuccessPage() {
  const { t } = useTranslation("billing");
  const { workspaceSlug } = Route.useParams();
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(5);

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          navigate({
            to: "/workspace/$workspaceSlug/settings/workspace/billing",
            params: { workspaceSlug },
          });
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [workspaceSlug, navigate]);

  const handleGoToBilling = () => {
    navigate({
      to: "/workspace/$workspaceSlug/settings/workspace/billing",
      params: { workspaceSlug },
    });
  };

  const handleGoToDashboard = () => {
    navigate({
      to: "/workspace/$workspaceSlug",
      params: { workspaceSlug },
    });
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] p-6">
      <div className="text-center max-w-md">
        <div className="flex justify-center mb-6">
          <div className="w-20 h-20 rounded-full bg-green-100 flex items-center justify-center">
            <CheckCircle className="w-12 h-12 text-green-600" />
          </div>
        </div>

        <h1 className="text-2xl font-bold mb-3">
          {t("payment_success.title", "Payment Successful!")}
        </h1>

        <p className="text-muted-foreground mb-6">
          {t(
            "payment_success.description",
            "Thank you for your purchase. Your payment has been processed successfully.",
          )}
        </p>

        <p className="text-sm text-muted-foreground mb-6">
          {t("payment_success.redirect", "Redirecting to billing page in {{seconds}} seconds...", {
            seconds: countdown,
          })}
        </p>

        <div className="flex justify-center gap-4">
          <Button variant="outline" onClick={handleGoToBilling}>
            {t("payment_success.go_to_billing", "Go to Billing")}
          </Button>
          <Button onClick={handleGoToDashboard}>
            {t("payment_success.go_to_dashboard", "Go to Dashboard")}
          </Button>
        </div>

        <div className="flex justify-center mt-6">
          <Loader2 className="w-5 h-5 animate-spin text-muted-foreground" />
        </div>
      </div>
    </div>
  );
}
